import React, {useState, useEffect} from 'react'
import styled, { keyframes } from 'styled-components';
import { fetchWrapper } from '../../utils/apiHandlers';
import InputComp from '../InputComp';
import Button from '../Button';
import TextboxComp from '../TextboxComp';
import HorizontalLine from '../horizontalLine';


interface Prop{
  user: any;
  openModal: (h:any, m: any, p?:any)=>void;
}

const TrainerComp : React.FC<Prop>=({user, openModal})=>{

    const [ userid, setuserid] = useState("")
    const [ email, setemail] = useState("")
    const [ firstname, setfirstname] = useState("")
    const [ lastname, setlastname] = useState("")
    const [ address, setaddress] = useState("")
    const [ phonenumber, setphonenumber] = useState("")
    const [ websiteurl, setwebsiteurl] = useState("")
    const [ businesstag, setbusinesstag ] = useState("")
    const [ businessdesc, setbusinessdesc ] = useState("")
    const [ businesstext, setbusinesstext ] = useState("")
    

    const crawlwebsite = async () => {
      try{
          openModal("Crawling", "", true)
          let response  = await fetchWrapper.post("/api/admin/crawlwebsite", {url: websiteurl})
          console.log(`response.text : ${JSON.stringify(response.text)}`)
          
          setbusinesstext(JSON.stringify(response.text))
          openModal("Done", "", false)
      }catch(error){
          openModal("Error", `${error}`, false)
      }
  }



  const updateuserinfo = async () => {
    openModal("Updating", "", true)
    let body = {
        id: user._id,
        firstname: firstname,
        lastname: lastname,
        address: address,
        phonenumber: phonenumber,
        websiteurl:websiteurl,
        businessdesc: businessdesc,
        businesstag: businesstag,
    }
    await fetchWrapper.post("/api/admin/updateuserprofile", {body}).then(r=>r)
    openModal("Done", "Profile updated", false)
    // loadusers()
}

  const toggleapprove = async () =>{
    try{
        await fetchWrapper.post("/api/admin/toggleapprove", {approve: !user.approve}).then(r=>r)
    }catch(error){
        console.log(`Error: ${error}`)            
    }
  }


  useEffect(()=>{
    setemail(user.email)
    setfirstname(user.firstname)
    setlastname(user.lastname)
    setaddress(user.address)
    setphonenumber(user.phonenumber)
    setwebsiteurl(user.websiteurl)
    setbusinessdesc(user.businessdesc)
    setbusinesstag(user.businesstag)

  }, [user])
  

  return(
    <MainContainer>
      {
        user?
        <Userdiv>
            <Item>
                Name: {`${user.firstname} ${user.lastname}`}
            </Item>
            <InputComp id="email_input"  placeholder="email" value={email} onChange={(e: any)=>setemail(e.target.value)} />
            <InputComp id="firstname_input"  placeholder="firstname" value={firstname} onChange={(e: any)=>setfirstname(e.target.value)} />
            <InputComp id="lastname_input"  placeholder="lastname" value={lastname} onChange={(e: any)=>setlastname(e.target.value)} />
            <InputComp id="address_input"  placeholder="address" value={address} onChange={(e: any)=>setaddress(e.target.value)} />
            <InputComp id="phonenumber_input"  placeholder="phonenumber" value={phonenumber} onChange={(e: any)=>setphonenumber(e.target.value)} />
            <InputComp id="websiteurl_input"  placeholder="websiteurl" value={websiteurl} onChange={(e: any)=>setwebsiteurl(e.target.value)} />
            <InputComp id="businesstag_input"  placeholder="business tag" value={businesstag} onChange={(e: any)=>setbusinesstag(e.target.value)} />

            <Item>
                STATUS: {`${user.approved?"Approved": "Pending"}`}
            </Item>

            <TextboxComp 
                id='tb_desc'
                placeholder='business description keywords/phrases separated by a comma'
                value={businessdesc}
                onChange={(e:any)=>setbusinessdesc(e.target.value)}
                rows={10} cols={50}
            />

            <ButtonContainer>
            <Button text="update" handleClick={updateuserinfo} />
            {
                user.approved?
                <Button text="withdraw" handleClick={toggleapprove} />:
                <Button text="approve" handleClick={toggleapprove} />
            }
            </ButtonContainer>

            <TextboxComp 
                id='tb_desc'
                placeholder='Website text'
                value={businesstext}
                onChange={(e: any)=>setbusinesstext(e.target.value)}
                rows={10} cols={50}
            />

            <ButtonContainer>
                <Button text="Crawl Website" handleClick={crawlwebsite} />
            </ButtonContainer>
        </Userdiv>:<></>
    }
    </MainContainer>
  );
}

const showAnimation = keyframes`
0% {
    opacity: 0
  }
  50% {
    opacity: 0.5
  }
  100% {
    opacity: 1;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
`

const RowHead = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 3px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 3px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }&:hover{
    background-color: #eee;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #000;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  @media (max-width: 770px) {
    padding: 20px 50px;
  }
`
const QAColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #000;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  @media (max-width: 770px) {
    padding: 20px 50px;
  }
`

const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const SubHeader = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 30px;
    justify-content: flex-end;
    color: black;
`;

const Item = styled.div`
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    color: black;
`;

const ButtonContainer = styled.div`
  display: flex;
`;

const Userdiv = styled.div`
    display: flex;
    flex-direction: column;
`;


export default TrainerComp